import { Box, Flex, Text } from '@chakra-ui/core';
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ShiftScheduleViewModel, ShiftRowViewModel } from '../utils/RequisitionDetailsViewModel';

import { ShiftGroupTable } from './ShiftGroupTable';

interface ShiftScheduleProps {
  shiftSchedule: ShiftScheduleViewModel;
}

export const ShiftSchedule = memo(({ shiftSchedule }: ShiftScheduleProps) => {
  const { t } = useTranslation('requisition');
  const { variant, weekdayRows, weekendRows } = shiftSchedule;

  const hasWeekendData = useMemo(
    () => weekendRows.some((row: ShiftRowViewModel) => row.slot1Start.exists || row.slot1End.exists),
    [weekendRows],
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      width="100%"
      py={3}
      data-testid="shift-schedule-section"
    >
      <Flex align="center" gridGap="6px" mb={2}>
        <Text fontSize="14px" fontWeight={700} data-testid="shift-schedule-title">
          {t('shiftSchedule')}
        </Text>

        <Text fontSize="13px" color="gray.500" data-testid="weekday-shift-title">
          {`(${t('weekdayShift')})`}
        </Text>
      </Flex>

      <Box width="100%" overflowX="auto">
        <ShiftGroupTable rows={weekdayRows} variant={variant} />

        {hasWeekendData && (
          <>
            <Box mt="12px" mb={2}>
              <Text fontSize="12px" fontWeight={600} color="gray.600" data-testid="weekend-shift-title">
                {t('weekendShift')}
              </Text>
            </Box>

            <ShiftGroupTable rows={weekendRows} variant={variant} />
          </>
        )}
      </Box>
    </Box>
  );
});
ShiftSchedule.displayName = 'ShiftSchedule';
